<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <h4>Dimensions</h4>
      </v-flex>
      <v-flex xs12 v-if="$v.room.$error">
        <div v-if="!$v.room.name.required" class="red--text">Please enter Name</div>
        <div v-if="type !== 'Curved Curtain' && !$v.room.width.required" class="red--text">Please enter Width</div>
        <div v-if="type !== 'Curved Curtain' && !$v.room.width.between && type !== 'Misc'" class="red--text">Please enter width between {{$v.room.width.$params.between.min}}mm and {{$v.room.width.$params.between.max}}mm</div>
        <div v-if="type === 'Curved Curtain' && !$v.room.widthLeft.required" class="red--text">Please enter Width Left</div>
        <div v-if="type === 'Curved Curtain' && !$v.room.widthLeft.between" class="red--text">Please enter Width Left between {{$v.room.widthLeft.$params.between.min}}mm and {{$v.room.widthLeft.$params.between.max}}mm</div>
        <div v-if="type === 'Curved Curtain' && corners === 'Two corners' && !$v.room.widthMiddle.required" class="red--text">Please enter Width Middle</div>
        <div v-if="type === 'Curved Curtain' && corners === 'Two corners' && !$v.room.widthMiddle.between" class="red--text">Please enter width Middle between {{$v.room.widthMiddle.$params.between.min}}mm and {{$v.room.widthMiddle.$params.between.max}}mm</div>
        <div v-if="type === 'Curved Curtain' && !$v.room.widthRight.required" class="red--text">Please enter Width Right</div>
        <div v-if="type === 'Curved Curtain' && !$v.room.widthRight.between" class="red--text">Please enter Width Right between {{$v.room.widthRight.$params.between.min}}mm and {{$v.room.widthRight.$params.between.max}}mm</div>
        <div v-if="!$v.room.drop.required && type !== 'Pelmets'" class="red--text">Please enter Drop</div>
        <div v-if="!$v.room.drop.between && type != 'Misc' && type !== 'Pelmets'" class="red--text">Please enter drop between {{$v.room.drop.$params.between.min}}mm and {{$v.room.drop.$params.between.max}}mm</div>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field label="Name" v-model="room.name" :v="$v.room.name"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4  v-if="type !== '3D Shutters' && type !== 'Curved Curtain'">
        <v-text-field label="Width" v-model="room.width" :v="$v.room.width"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4  v-if="type === 'Curved Curtain'">
        <v-text-field label="Width Left" v-model="room.widthLeft" :v="$v.room.widthLeft"></v-text-field>
        <v-text-field v-if="corners === 'Two corners'" label="Width Middle" v-model="room.widthMiddle" :v="$v.room.widthMiddle"></v-text-field>
        <v-text-field label="Width Right" v-model="room.widthRight" :v="$v.room.widthRight"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4 v-if="type !== 'Pelmets'">
        <v-text-field label="Drop" v-model="room.drop" :v="$v.room.drop"></v-text-field>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </div>
</template>
<script>
import { required, between } from 'vuelidate/lib/validators'

export default {
  props: {
    error: false,
    type: '',
    valueName: '',
    valueWidth: '',
    valueWidthLeft: '',
    valueWidthMiddle: '',
    valueWidthRight: '',
    corners: '', // for Curved Curtain only
    valueDrop: '',
    valueFabric: null,
    valueStackOption: null
  },
  data () {
    return {
      room: {
        name: null,
        width: null,
        widthLeft: null,
        widthMiddle: null,
        widthRight: null,
        drop: null
      },
      minWidth: 0,
      maxWidth: 0,
      minDrop: 0,
      maxDrop: 0
    }
  },
  validations () {
    if (this.type === 'Misc') {
      return {
        room: {
          name: { required },
          width: { required },
          drop: { required }
        }
      }
    } else if (this.type === 'Pelmets') {
      return {
        room: {
          name: { required },
          width: { required, between: between(this.minDrop, this.maxDrop) }
        }
      }
    } else if (this.type === '3D Shutters') {
      return {
        room: {
          name: { required },
          drop: { required, between: between(this.minDrop, this.maxDrop) }
        }
      }
    } else if (this.type === 'Curved Curtain') {
      if (this.corners === 'Two corners') {
        return {
          room: {
            name: { required },
            widthLeft: { required, between: between(this.minWidth, this.maxWidth) },
            widthMiddle: { required, between: between(this.minWidth, this.maxWidth) },
            widthRight: { required, between: between(this.minWidth, this.maxWidth) },
            drop: { required, between: between(this.minDrop, this.maxDrop) }
          }
        }
      } else {
        return {
          room: {
            name: { required },
            widthLeft: { required, between: between(this.minWidth, this.maxWidth) },
            widthRight: { required, between: between(this.minWidth, this.maxWidth) },
            drop: { required, between: between(this.minDrop, this.maxDrop) }
          }
        }
      }
    } else {
      return {
        room: {
          name: { required },
          width: { required, between: between(this.minWidth, this.maxWidth) },
          drop: { required, between: between(this.minDrop, this.maxDrop) }
        }
      }
    }
  },
  watch: {
    corners: function (val) {
      this.room.widthMiddle = null
    },
    valueName: function (val) {
      this.room.name = val
    },
    valueWidth: function (val) {
      this.room.width = val
    },
    valueWidthLeft: function (val) {
      this.room.widthLeft = val
    },
    valueWidthMiddle: function (val) {
      this.room.widthMiddle = val
    },
    valueWidthRight: function (val) {
      this.room.widthRight = val
    },
    valueDrop: function (val) {
      this.room.drop = val
    },
    valueFabric: function (val) {
      this.setMinMax()
    },
    valueStackOption: function (val) {
      this.setMinMax()
    },
    room: {
      handler (val) {
        this.$emit('room', val)
      },
      deep: true
    },
    ready (val) {
      this.$emit('ready', val)
    }
  },
  methods: {
    touch () {
      this.$v.room.$touch()
    },
    setMinMax () {
      console.log(this.type)
      if (this.type === 'Panel Glide Blind') {
        this.minWidth = 300
        this.maxWidth = 4800
        this.minDrop = 600
        this.maxDrop = 3300
      } else if (this.type === 'Curved Curtain' || this.type === 'Curtain' || this.type === 'Double Curtain' || this.type === 'Lined Curtain') {
        this.minWidth = 400
        /* this.maxWidth = 5750
        if (this.valueStackOption === 'Centre Open') {
          this.maxWidth = 11500
        } */
        this.maxWidth = 11500
        this.minDrop = 400
        this.maxDrop = 4200
      } else if (this.type === 'Shutter') {
        this.minWidth = 300
        this.maxWidth = 3600
        this.minDrop = 400
        this.maxDrop = 3000
      } else if (this.type === '3D Shutters') {
        this.minWidth = 300
        this.maxWidth = 3600
        this.minDrop = 400
        this.maxDrop = 3000
      } else if (this.type === 'Roller Blind' || this.type === 'Double Roller Blind') {
        this.minWidth = 300
        this.maxWidth = 4000
        this.minDrop = 400
        this.maxDrop = 3300
      } else if (this.type === 'Vertical Blind') {
        this.minWidth = 300
        this.maxWidth = 5775
        this.minDrop = 400
        this.maxDrop = 3650
      } else if (this.type === 'Venetian Blind') {
        this.minWidth = 300
        this.maxWidth = 2400
        this.minDrop = 400
        this.maxDrop = 2600
        switch (this.valueFabric) {
          case '5b46c82f8268963885373f24': // 25mm Aluminium
            this.maxWidth = 3600
            this.maxDrop = 3300
            break
          case '5b46c84c8268963885373f48': // 50mm Aluminium
            this.maxWidth = 3000
            this.maxDrop = 3300
            break
          case '5b46c82f8268963885373f25': // 50mm Visionwood
            this.maxWidth = 2400
            this.maxDrop = 2600
            break
          case '5b46c84c8268963885373f57': // 63mm Visionwood
            this.maxWidth = 2400
            this.maxDrop = 2550
            break
          case '5b46c84c8268963885373f55': // Timber - (Purewood - Shadow)
          case '5b46c84c8268963885373f5c': // Timber - (Purewood - Urban)
          case '5b46c84c8268963885373f62': // Timber - (Purewood - Pastel)
            this.maxWidth = 2400
            this.maxDrop = 2600
            break
        }
      } else if (this.type === 'Roman Blind') {
        this.minWidth = 300
        this.maxWidth = 2900
        this.minDrop = 400
        this.maxDrop = 3000
      /* } else if (this.valueFabric === '5b46c82f8268963885373f25' || this.valueFabric === '5b46c84c8268963885373f57') {
        this.minWidth = 300
        this.maxWidth = 2400
        this.minDrop = 400
        this.maxDrop = 3000 */
      } else {
        this.minWidth = 300
        this.maxWidth = 3000
        this.minDrop = 400
        this.maxDrop = 3000
      }
    }
  },
  computed: {
    ready () {
      return !this.$v.room.$invalid
    }
  },

  created () {
    this.setMinMax()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/parts/DimensionSelector.vue